
import validator from "validator";

const validateZipCode = (value: string | null, city = "") => {
  if (!value) {
    return {
      isValid: false,
      message: "Veuillez entrer un code postal",
    };
  }

  if (!validator.isPostalCode(value, 'FR')) {
    return {
      isValid: false,
      message: "Veuillez entrer un code postal valide",
    };
  }

  return {
    isValid: true,
    message: "",
  };
};

export default validateZipCode
